module.exports = __webpack_public_path__ + "img/logo.717d9518.svg";